import { render, staticRenderFns } from "./paid.vue?vue&type=template&id=59d81c40&scoped=true"
import script from "./paid.vue?vue&type=script&lang=js"
export * from "./paid.vue?vue&type=script&lang=js"
import style0 from "./paid.vue?vue&type=style&index=0&id=59d81c40&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d81c40",
  null
  
)

export default component.exports